import React, { useContext } from "react";
import classes from "./NavItem.module.css";
import { Link } from "react-scroll";
import { ThemeContext } from "../../../../ThemeProvider";

import { motion } from "framer-motion";

const NavItem = ({
  offset,
  to,
  name,
  num,
  delay,
  isMobile,
  setMenuToggler,
}) => {
  const { dark } = useContext(ThemeContext);
  offset = Number(offset);
  delay = Number(delay);

  const animateFrom = { opacity: 0, y: -40 };
  const animateTo = { opacity: 1, y: 0 };

  return (
    <motion.li
      initial={animateFrom}
      animate={animateTo}
      transition={{ delay: delay, duration: 0.5, type: "tween" }}
    >
      {" "}
      <Link
        offset={offset}
        to={to}
        smooth={true}
        className={
          dark
            ? `${classes.nav__link} ${classes.nav__link__dark} `
            : classes.nav__link
        }
        onClick={() => isMobile && setMenuToggler(false)}
      >
        <span
          className={
            dark
              ? `${classes.nav__num} ${classes.nav__num__dark} `
              : classes.nav__num
          }
        >
          {num}.{" "}
        </span>
        {name}
      </Link>
    </motion.li>
  );
};

export default NavItem;
